/*                                                   */
import type { EventHandler, HTMLAttributes } from "svelte/elements";
import { type AsyncNamespace, otto, type OttoNexus } from "@otto-ec/global-resources/nexus";
import type { SetCookieOptions } from "@otto-ec/global-resources/cookie";
import type { CommonAttributes, CommonEvents, CommonProps } from "./component.types.js";

declare global {
  /*                                                               */
  interface HTMLElementEventMap extends CommonEvents<never, unknown> {}

  /*                                         */
  interface OttoComponentApi {
    /**
 *
 */
    version: () => string;

    /**
 *
 *
 *
 *
 *
 */
    setColorScheme(
      colorScheme: "dark" | "auto" | "light" | null,
      options?: SetCookieOptions | null,
    ): void;

    /**
 *
 */
    asyncComponentsLoaded: undefined | true;
  }

  /*                                    */
  interface NexusInterfaces {
    /**
 *
 *
 */
    components: AsyncNamespace<OttoComponentApi>;
  }
}

/**
 *
 */
export type OttoComponents = OttoNexus["components"];

/**
 *
 *
 */
/*                                            */
export const components: OttoComponents = otto.components;

type EventListener<Events> = {
  addEventListener<K extends keyof Events>(
    type: K,
    listener: (this: Element, ev: Events[K]) => any,
    options?: boolean | AddEventListenerOptions,
  ): void;

  removeEventListener<K extends keyof Events>(
    type: K,
    listener: (this: Element, ev: Events[K]) => any,
    options?: boolean | EventListenerOptions,
  ): void;
};

type AttributeMethods<Attributes> = {
  setAttribute(name: keyof Attributes, value: string): void;
  removeAttribute(qualifiedName: keyof Attributes): void;
  getAttribute(qualifiedName: keyof Attributes): string | null;
  hasAttribute(qualifiedName: keyof Attributes): boolean;
};

export type OttoComponentsHTMLElement<Attributes, Props, Events, Methods> = Props &
  CommonProps &
  Methods &
  AttributeMethods<Attributes & CommonAttributes> &
  EventListener<Events> &
  HTMLElement;

type EventHandlerMap<Events extends Record<string, any>, OttoElement extends EventTarget> = {
  [PE in keyof Events as PE extends string ? PE : never]?: EventHandler<Events[PE], OttoElement>;
};

/**
 *
 */
export type OttoComponentsEventHandlerMap<Element extends EventTarget, Events> = EventHandlerMap<
  Events & HTMLElementEventMap,
  Element
>;

/**
 *
 */
type SvelteEvents<Events extends Record<string, any>, OttoElement extends EventTarget> = {
  [PE in keyof Events as PE extends string ? `on${PE}` : never]?: EventHandler<
    Events[PE],
    OttoElement
  >;
} & {
  /*                  */
  [PE in keyof Events as PE extends string ? `on:${PE}` : never]?: EventHandler<
    Events[PE],
    OttoElement
  >;
};

/**
 *
 */
export type OttoComponentsSvelteElement<
  Element extends EventTarget,
  Attributes,
  Events,
> = Attributes &
  CommonProps &
  HTMLAttributes<Element> &
  SvelteEvents<Events & HTMLElementEventMap, Element>;
